import { useEffect } from 'react'
import { Title } from '~components'
import { useStore, useNavigate, usePathValidation } from '~hooks'
import * as Styled from './styled'

function SelfieConfirmation() {
  const navigate = useNavigate()
  const { register, update } = useStore()

  usePathValidation(['register.selfie'])
  useEffect(() => {
    update({ register: { progress: 80 } })
  }, [update])

  function handleClickNext() {
    navigate('/cadastrar/senha', { state: { previousPath: '/cadastrar/selfie/confirmacao'}})
  }
  function handleClickTryAgain() {
    navigate('/cadastrar/selfie/tirar', { state: { previousPath: '/cadastrar/selfie/confirmacao'}})
  }

  return (
    <>
      <Title>Tudo certo com a sua foto?</Title>
      <Styled.Image src={register.selfie} alt="Imagem prévia de sua selfie" />
      <Styled.PrimaryButton width="100%" type="button" onClick={handleClickNext}>
        Tudo certo
      </Styled.PrimaryButton>
      <Styled.SecondaryButton
        color="tertiary"
        width="100%"
        type="button"
        onClick={handleClickTryAgain}
      >
        Tirar foto novamente
      </Styled.SecondaryButton>
    </>
  )
}

export default SelfieConfirmation
